import { createReducer } from '@reduxjs/toolkit';
import { disconnected } from '../thunks/subscriptions.thunks';
import {
  datasetLoaded,
  datasetsLoadAllFinished,
  datasetRemoved,
  datasetRolledBack,
  datasetCommitted,
  datasetsUpdated,
  datasetsAdded,
  datasetsDeleted,
} from '../thunks/datasets.thunks';
import { decorateDataset } from '../../utils/datasets.utils';
import { Dataset, DatasetMap } from 'Types/dataset.types';

// -----------------------------------------------------------------------------

type DatasetsState = DatasetMap;
const initialState: DatasetsState = {};

/*
Note: We are using the builder callback for creating a typesafe reducer.
See https://redux-toolkit.js.org/usage/usage-with-typescript#building-type-safe-reducer-argument-objects
*/
export const datasetsReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(disconnected, () => initialState)
    .addCase(datasetLoaded, (state, { payload }) => {
      state[payload.id] = decorateDataset(payload.dataset);
    })
    .addCase(datasetsLoadAllFinished, (state, action) => {
      const newState: DatasetMap = {};
      for (let i = 0; i < action.payload.length; i++) {
        newState[action.payload[i]._id] = decorateDataset(action.payload[i]);
      }
      return newState;
    })
    .addCase(datasetRemoved, (state, action) => {
      delete state[action.payload];
    })
    .addCase(datasetRolledBack, (state, action) => {
      if (state[action.payload]) {
        state[action.payload].runtime['circuit-breaker-tripped'] = false;
      }
    })
    .addCase(datasetCommitted, (state, action) => {
      if (state[action.payload]) {
        state[action.payload].runtime['circuit-breaker-tripped'] = false;
      }
    })
    .addCase(datasetsAdded, (state, action) => {
      action?.payload?.forEach((dataset) => {
        state[dataset._id] = decorateDataset(dataset);
      });
    })
    .addCase(datasetsUpdated, (state, action) => {
      action.payload.forEach((dataset) => {
        state[dataset._id] = decorateDataset(dataset);
      });

      return state;
    })
    .addCase(datasetsDeleted, (state, action) => {
      action?.payload?.forEach((dataset) => {
        delete state[dataset._id];
      });
    })
);
